
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { FlowDraftItem } from '../../../spacesPlatform/models/resourceParts';
import { ISingleIdParams } from '../../../spacesPlatform/utils/actionParams';

export type GetFlowDraftResult = FlowDraftItem;

export class GetFlowDraftRequest extends Request<ISingleIdParams, GetFlowDraftResult> {
  constructor(params: ISingleIdParams) {
    super('getFlowDraft', params);
  }
}
